var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkFilledNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2608205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7185 5.71866C14.7185 4.20198 14.116 2.74741 13.0436 1.67496C11.9711 0.6025 10.5165 0 8.99987 0C7.48318 0 6.02862 0.6025 4.95616 1.67496C3.88371 2.74741 3.28121 4.20198 3.28121 5.71866C3.28121 12.3904 0.421875 14.2967 0.421875 14.2967H17.5779C17.5779 14.2967 14.7185 12.3904 14.7185 5.71866Z",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 16C11.6951 16.6083 11.2575 17.1132 10.731 17.4642C10.2045 17.8153 9.60759 18 9 18C8.39241 18 7.79547 17.8153 7.26897 17.4642C6.74247 17.1132 6.30487 16.6083 6 16",
    fill: "#303336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkFilledNotificationIcon);
export default __webpack_public_path__ + "static/media/darkFilledNotificationIcon.9554ed1260b96a9142a9107810f2835f.svg";
export { ForwardRef as ReactComponent };